import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FooterComponent } from '../../../shared/components/footer/footer';
import { HeaderComponent } from '../components/header/header';

@Component({
  selector: 'app-viewer-layout',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    FooterComponent,
    HeaderComponent
  ],
  templateUrl: './viewer-layout.html',
  styleUrl: './viewer-layout.scss',
})
export class ViewerLayoutComponent {}
